import { Component } from '@angular/core';

@Component({
  selector: 'usucampeao-projeto-atendendo-devolutivas-cartorio',
  templateUrl: './projeto-atendendo-devolutivas-cartorio.component.html',
  styleUrls: ['./projeto-atendendo-devolutivas-cartorio.component.scss'],
})
export class ProjetoAtendendoDevolutivasCartorioComponent { }
